<template>
  <div>
    <a-card
      :bordered="false"
      :title="status==='create'?'新增页面':'编辑页面'"
    >
      <a-button
        slot="extra"
        @click="handleCancel"
        class="mr-10"
      >
        取消
      </a-button>
      <a-button
        slot="extra"
        type="primary"
        :loading="confirmLoading"
        @click="handleSave"
      >
        保存
      </a-button>
      <div style="overflow: auto; min-height:700px">
        <div class="box">
          <a-form-model
            ref="form"
            :model="formData"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            class="box-left"
          >
            <div class="form-title">基本信息</div>
            <a-form-model-item
              v-if="status==='edit'"
              label="页面链接"
            >
              {{ formData.page_url }}
            </a-form-model-item>
            <a-form-model-item
              label="页面名称"
              prop="title"
            >
              <a-input
                v-model="formData.title"
                placeholder="请输入页面名称"
                allowClear
              />
            </a-form-model-item>
            <a-form-model-item
              label="页面类型"
              prop="page_type"
              required
            >
              <a-radio-group v-model="formData.page_type" @change="changePageType">
                <a-radio
                  v-for="item in dict.pageTypeDict"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item
              label="默认首页"
              required
            >
              <a-radio-group>
                <a-checkbox :checked="is_home" @change="isHome"></a-checkbox>
              </a-radio-group>
              <a-select v-if="is_home" style="width: 300px; margin-left: 20px" placeholder="选择品牌" v-model="formData.brand_id">
                <a-select-option v-for="(item, index) in brand_list" :key="index" :value="item.brand_id" v-if="item.is_ban" disabled>{{ item.brand_name }}</a-select-option>
                <a-select-option v-for="(item, index) in brand_list" :key="index+999" :value="item.brand_id" v-if="!item.is_ban">{{ item.brand_name }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <!-- 自定义页面 -->
            <template v-if="formData.page_type==='NORMAL'">
              <!--轮播图start-->
              <div class="form-title">轮播图
                <a-button
                  v-if="formData.banner.length<5"
                  type="primary"
                  size="small"
                  class="ml-10"
                  @click="handleAddBanner"
                >
                  添加轮播图
                </a-button>
              </div>
              <div class="form-sub-title">图片尺寸建议750px * 400px</div>
              <a-empty v-if="!formData.banner.length">
                <span slot="description">没有添加轮播图</span>
              </a-empty>
              <template v-if="formData.banner.length">
                <a-card v-for="(item, index) in formData.banner" :title="`${index+1}、图片`" :key="`${index+10}`" size="small" class="mt-10">
                  <a-icon
                    slot="extra"
                    type="delete"
                    @click="handleDeleteBanner($event, item, index)"
                  />
                  <div class="flex-box">
                    <a-form-model-item
                      :rules="{ required: true, message: '图片必填', trigger: 'change'}"
                      :prop="'banner.' + index + '.banner_url'"
                    >
                      <up-load v-model="item.banner_url" />
                    </a-form-model-item>
                    <div class="flex-box-grow-1">
                      <a-form-model-item
                        label="轮播序号"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 16 }"
                        :prop="'banner.' + index + '.sort'"
                        :rules="{ required: true, message: '展示顺序必填', trigger: 'blur'}"
                      >
                        <a-input-number
                          v-model="item.sort"
                          placeholder="填写展示顺序"
                        />
                      </a-form-model-item>
                      <a-form-model-item
                        label="跳转页面"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 16 }"
                        :prop="'banner.' + index + '.jump_url'"
                      >
                        <div @click="handleSelectLinkB(item, index)">
                          <a-textarea
                            v-model="item.jump_url"
                            placeholder="点击选择链接"
                          />
                        </div>
                      </a-form-model-item>
                    </div>
                  </div>
                </a-card>
              </template>
              <!--轮播图end-->
              <!--导航start-->
              <div class="form-title">导航栏
                <a-button
                  v-if="formData.navigation.length<10"
                  type="primary"
                  size="small"
                  class="ml-10"
                  @click="handleAddNav"
                >
                  添加导航
                </a-button>
              </div>
              <div class="form-sub-title">最多添加10个导航，最多排列两行，每行最多5个</div>
              <a-empty v-if="!formData.navigation.length">
                <span slot="description">还未添加导航</span>
              </a-empty>
              <template v-if="formData.navigation.length">
                <a-card v-for="(item, index) in formData.navigation" :title="`${index+1}、${item.title || '导航'}`" :key="index" size="small" class="mt-10">
                  <a-icon
                    slot="extra"
                    type="delete"
                    @click="handleDeleteNav($event, item, index)"
                  />
                  <div class="flex-box">
                    <a-form-model-item
                      :prop="'navigation.' + index + '.icon'"
                      :rules="{ required: true, message: '图片必填', trigger: 'change'}"
                    >
                      <up-load v-model="item.icon" />
                    </a-form-model-item>
                    <div class="flex-box-grow-1">
                      <a-form-model-item
                        label="导航序号"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 16 }"
                        :prop="'navigation.' + index + '.sort'"
                        :rules="{ required: true, message: '展示顺序必填', trigger: 'blur'}"
                      >
                        <a-input-number
                          v-model="item.sort"
                          placeholder="填写展示顺序"
                        />
                      </a-form-model-item>
                      <a-form-model-item
                        label="导航文本"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 16 }"
                        :prop="'navigation.' + index + '.title'"
                        :rules="{ required: true, message: '导航文本必填', trigger: 'blur'}"
                      >
                        <a-input
                          v-model="item.title"
                          :maxLength="6"
                          placeholder="不超过6个字"
                          allowClear
                        />
                      </a-form-model-item>
                      <a-form-model-item
                        label="跳转页面"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 16 }"
                        :prop="'navigation.' + index + '.url'"
                        :rules="{ required: true, message: '说明书', trigger: 'blur'}"
                      >
                        <div @click="handleSelectLink(item, index)">
                          <a-textarea
                            v-model="item.url"
                            placeholder="点击选择链接"
                          />
                        </div>
                      </a-form-model-item>
                    </div>
                  </div>
                </a-card>
              </template>
              <!--导航end-->
              <!--视频start-->
              <div class="form-title">视频组
                <a-button
                  type="primary"
                  size="small"
                  class="ml-10"
                  @click="handleAddVideo"
                >添加视频</a-button>
              </div>
              <div class="form-sub-title">建议 视频封面 和 视频 尺寸相同</div>
              <a-card v-for="(item, index) in formData.video" :title="`${item.title || '视频组'}${index+1}`" :key="`${index+30}`" size="small" class="mt-10">
                <a-icon
                  slot="extra"
                  type="delete"
                  @click="handleDeleteVideo($event, item, index)"
                />
                <a-form-model-item>
                  <up-load v-model="formData.video[index].pic_url"/>
                  <up-load-video v-model="formData.video[index].video_url" />
                </a-form-model-item>
              </a-card>
              <!--视频end-->
              <!--图片展示start-->
              <div class="form-title">图片展示
                <a-button
                  type="primary"
                  size="small"
                  class="ml-10"
                  @click="handleAddContent"
                >
                  添加图片
                </a-button>
              </div>
              <div class="form-sub-title">图片尺寸建议750px * 400px</div>
              <a-empty v-if="!formData.content.length">
                <span slot="description">还未添加图片</span>
              </a-empty>
              <template v-if="formData.content.length">
                <a-card v-for="(item, index) in formData.content" :title="`${index+1}、图片`" :key="`${index+20}`" size="small" class="mt-10">
                  <a-icon
                    slot="extra"
                    type="delete"
                    @click="handleDeleteContent($event, item, index)"
                  />
                  <div class="flex-box">
                    <a-form-model-item
                      :prop="'content.' + index + '.content_url'"
                      :rules="{ required: true, message: '图片必填', trigger: 'change'}"
                    >
                      <up-load v-model="item.content_url" />
                    </a-form-model-item>
                    <div class="flex-box-grow-1">
                      <a-form-model-item
                        label="导航序号"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 16 }"
                        :prop="'content.' + index + '.sort'"
                        :rules="{ required: true, message: '展示顺序必填', trigger: 'blur'}"
                      >
                        <a-input-number
                          v-model="item.sort"
                          placeholder="填写展示顺序"
                        />
                      </a-form-model-item>
                      <a-form-model-item
                        label="跳转页面"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 16 }"
                        :prop="'content.' + index + '.jump_url'"
                      >
                        <div @click="handleSelectLinkC(item, index)">
                          <a-textarea
                            v-model="item.jump_url"
                            placeholder="点击选择链接"
                          />
                        </div>
                      </a-form-model-item>
                    </div>
                  </div>
                </a-card>
              </template>
              <!--图片展示end-->
            </template>
            <!-- 自定义页面 end -->
            <!-- 产品说明页 start-->
            <template v-if="formData.page_type==='PRODUCT'">
              <a-form-model-item
                label="说明书"
              >
                <up-load-mult v-model="formData.picture" />
              </a-form-model-item>
            </template>
            <!-- 产品说明页 end-->
            <!-- 联系页 start-->
            <template v-if="formData.page_type==='CONTACT'">
              <div class="form-title">展示内容
                <a-button
                  type="primary"
                  size="small"
                  class="ml-10"
                  @click="handleAddContact"
                >
                  添加选项
                </a-button>
              </div>
              <div class="form-sub-title">可添加纯文本，联系电话，图片三种类型的选项</div>
              <div class="card mt-10" v-for="(item, index) in formData.contact_units" :key="`contact${index}`">
                <div class="head">
                  <div class="title">
                    {{ index + 1 }}、
                    <a-select v-model="item.unit_type" placeholder="请选择" style="width: 120px">
                      <a-select-option value="TEXT">
                        纯文本
                      </a-select-option>
                      <a-select-option value="NUMBER">
                        联系电话
                      </a-select-option>
                      <a-select-option value="PIC">
                        上传图片
                      </a-select-option>
                    </a-select>
                  </div>
                  <div class="extra">
                    <a-icon type="delete" @click="handleDeleteContact(item, index)" />
                  </div>
                </div>
                <div class="body">
                  <a-form-model-item
                    label="排序"
                  >
                    <a-input-number v-model="item.sort" :min="0" :precision="0" />
                  </a-form-model-item>
                  <a-form-model-item
                    label="字段名"
                  >
                    <a-input v-model="item.title" />
                  </a-form-model-item>
                  <a-form-model-item
                    v-if="item.unit_type!=='PIC'"
                    label="内容"
                  >
                    <a-textarea v-model="item.content" />
                  </a-form-model-item>
                  <a-form-model-item
                    v-if="item.unit_type==='PIC'"
                    label="图片"
                  >
                    <up-load-mult v-model="item.pic" />
                  </a-form-model-item>
                </div>
              </div>
            </template>
            <!-- 联系页 end-->
          </a-form-model>
          <!-- 效果预览 -->
          <div
            v-if="status==='edit'"
            class="box-right"
          >
            <div class="form-title">点击保存后，即可浏览页面效果。
              <a-button
                type="primary"
                size="small"
                class="ml-10"
                @click="handleRefreshPreview"
              >
                刷新
              </a-button>
            </div>
            <div class="phone-box">
              <iframe
                name="pageIframe"
                id="pageIframe"
                frameborder="0"
                width="100%"
                height="100%"
                :src="`${formData.page_url}?_auth=YES`"
                allowFullScreen="true"
              />
            </div>
          </div>
        </div>
      </div>
    </a-card>
    <!-- 选择链接 -->
    <Link ref="link" @ok="handleLinkOk" />
    <Link ref="linkB" @ok="handleLinkOkB" />
    <Link ref="linkC" @ok="handleLinkOkC" />
    <!-- 预览图片 -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible=false"
    >
      <img
        alt="example"
        style="width: 100%; margin-top:30px"
        :src="previewImage"
      />
    </a-modal>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import UpLoad from '@/components/UpLoad'
import UpLoadMult from '@/components/UpLoadMult'
import UpLoadVideo from '@/components/video'
import wangEditor from '@/components/wangEditor'
import Link from '@/components/Link'
import { deepClone, formatPath } from '@/utils'
import { valInDict } from '@/utils/util'
import { getBrandList } from '@/api/brand'
import { getPagesPre, getPagesDetail, postPagesAdd, postPagesEdit } from '@/api/pages'

const defaultNav = {
  sort: 0,
  title: '',
  icon: '',
  url: '',
  goods_id: ''
}
const defaultVideo = {
  video_url: '',
  pic_url: ''
}
const defaultBanner = {
  banner_url: '',
  jump_url: '',
  goods_id: '',
  page_id: '',
  sort: 0
}
const defaultContent = {
  content_url: '',
  jump_url: '',
  goods_id: '',
  page_id: '',
  sort: 0
}
const defaultContact = {
  unit_type: 'TEXT',
  content: '',
  sort: 0,
  pic: [],
  title: ''
}

const defaultFormData = {
  title: '',
  page_type: 'NORMAL',
  is_index: 'NO',
  navigation: [Object.assign({}, defaultNav)], // 自定义页面导航栏（[{title:'导航名称','icon':'图标地址','sort':'排序','goods_id':'关联商品ID','page_id':'管理页面ID'}]）.
  picture: [], // 产品说明图片
  video: [Object.assign({}, defaultVideo)], // 视频封面和视频
  banner: [Object.assign({}, defaultBanner)], // 轮播图
  content: [Object.assign({}, defaultContent)], // 自定义页面内容.
  contact_units: [Object.assign({}, defaultContact)], // 联系页内容
  brand_id: 1, // 品牌id
  is_ban: false
}

export default {
  name: 'CustomPageForm',
  components: { draggable, UpLoad, UpLoadMult, UpLoadVideo, Link, wangEditor },
  data() {
    return {
      id: '',
      status: 'create',
      is_home: false,
      confirmLoading: false,
      labelCol: { xxl: { span: 3 }, xl: { span: 4 }, lg: { span: 5 }, md: { span: 6 }, sm: { span: 8 }, xs: { span: 8 } },
      wrapperCol: { xxl: { span: 14 }, xl: { span: 16 }, lg: { span: 16 }, md: { span: 16 }, sm: { span: 16 }, xs: { span: 16 } },
      formData: Object.assign({}, defaultFormData),
      dict: {
        urlDict: [{ id: 'http://h5.fw.czyugang.cn:7862/h', name: 'wap_page_host' }, { id: 'http://h5.fw.czyugang.cn:7862/p', name: 'wap_goods_host' }, { id: 'http://h5.fw.czyugang.cn:7862/ps', name: 'wap_goodsspec_host' }, { id: 'http://h5.fw.czyugang.cn:7862/ct', name: 'wap_contact_host' }],
        pageTypeDict: []
      },
      brand_list: [],
      rules: {
        title: [{ required: true, message: '页面名称必填' }],
        page_type: [{ required: true, message: '页面类型必填' }]
      },
      // 选择链接
      currentNavIndex: 0,
      currentBannerUrl: 0,
      currentContentUrl: 0,
      // 预览图片
      previewVisible: false,
      previewImage: '',
      timer: null
    }
  },
  created() {
    this.id = this.$route.query && this.$route.query.id ? this.$route.query.id : ''
    if (this.id) {
      // 编辑
      this.status = 'edit'
      this.getDetail()
    } else {
      this.status = 'create'
      this.formData = Object.assign({}, defaultFormData)
    }
    this.getPre()
  },
  watch: {
    formData: {
      handler() {
        if (this.status === 'edit') {
          // 向IFRAME通信
          this.postMessage()
        }
      },
      deep: true
    }
  },
  methods: {
    // 修改页面类型，不同类型，不同链接
    changePageType() {
      if (this.status === 'create') {
        return
      }
      // /id/id
      const ids = this.formData.page_url.split('/').slice(4).join('/')
      // 自定义
      if (this.formData.page_type === 'NORMAL') {
        const pHost = valInDict('wap_page_host', this.dict.urlDict, 'name', 'id')
        this.formData.page_url = pHost + '/' + ids
      }
      // 产品说明
      if (this.formData.page_type === 'PRODUCT') {
        const psHost = valInDict('wap_goodsspec_host', this.dict.urlDict, 'name', 'id')
        this.formData.page_url = psHost + '/' + ids
      }
      // 联系页
      if (this.formData.page_type === 'CONTACT') {
        const ctHost = valInDict('wap_contact_host', this.dict.urlDict, 'name', 'id')
        this.formData.page_url = ctHost + '/' + ids
      }
      this.handleRefreshPreview()
    },
    // 向IFRAME通信传值
    postMessage () {
      const iframe = document.getElementById('pageIframe')
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        iframe.contentWindow.postMessage(this.formData, this.formData.page_url)
      }, 2000)
    },
    // 预览图片
    // handlePreviewImg(imgUrl) {
    //   if (!imgUrl) {
    //     this.$message.success('还未上传图片')
    //     return false
    //   }
    //   this.previewImage = imgUrl
    //   this.previewVisible = true
    // },
    // 预加载
    getPre() {
      // 获取品牌时排除已经存在的品牌首页， 如果是编辑，则不
      var param = []
      if (this.status === 'edit') {
        param = [2, this.id]
      } else {
        param = [2, -1]
      }
      getBrandList(param)
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.brand_list = data

            // 新增页面且未添加首页的品牌列表大于0时，设置默认选择
            if (this.formData.is_index === 'NO') this.setDefault(data)
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
      getPagesPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.dict.pageTypeDict = data.pageTypeDict
            this.dict.urlDict = data.urlDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    },
    // 禁止选择并提示
    // showTips() {
    //   if (this.time === 0) {
    //     var thi = this
    //     this.time = 1
    //     this.$message.warning('该品牌已创建有首页，不可同时有多个首页')
    //     setTimeout(function () {
    //       thi.time = 0
    //     }, 3000)
    //   }
    // },
    // 新增页面且未添加首页的品牌列表大于0时，设置默认选择
    setDefault(data, type = '') {
      if (data.length > 0) {
        var arr = []
        for (var i = 0; i < data.length; i++) {
          if (!data[i].is_ban) {
            arr.push(data[i].brand_id)
          }
        }
        if (arr.length > 0) {
          if (type === '') {
            // 设置首页
            this.formData.brand_id = arr[0]
          } else {
            return true
          }
        } else {
          return false
        }
      }
    },
    // 详情
    getDetail() {
      getPagesDetail({
        page_id: this.id
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.formData = deepClone(data)
            if (data.is_index === 'YES') {
              this.is_home = true
            }
            // this.content = this.formData.content
          }
        })
        .catch((e) => {
          this.$message.error('请求详情失败')
        })
    },
    // 点击 取消 按钮
    handleCancel() {
      // this.$router.go(-1)
      this.$router.push({ name: 'dashboard' })
    },
    // 保存
    handleSave() {
      this.$refs.form.validate((valid) => {
        // 封面存在时， 必须上传视频，视频存在但没有上传封面时用视频的首贞做封面
        var video = this.formData.video
        for (var i = 0; i < video.length; i++) {
          if (!video[i].video_url) {
            // 没有视频时删除组件
            video.splice(i, 1)
            i--
            continue
          }
          if (!video[i].pic_url) {
            this.formData.video[i].pic_url = video[i].video_url + '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto'
          }
        }
        if (valid) {
          if (this.id) {
            // 编辑
            this.postEdit()
          } else {
            // 新增
            this.postAdd()
          }
        } else {
          this.$message.error('还有字段未填写，请检查！')
          return false
        }
      })
    },
    // 掉数组中的空字符串
    trimSpace(array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] === '' || array[i] === null || typeof array[i] === 'undefined') {
          array.splice(i, 1)
          i = i - 1
        }
      }
      return array
    },
    // 转换成接口所需参数
    paramsFormat() {
      let picture = []
      if (this.formData.picture && this.formData.picture.length) {
        picture = this.trimSpace(this.formData.picture).map(formatPath)
      }
      const navigation = deepClone(this.formData.navigation)
      navigation.map((item, index) => {
        navigation[index].icon = formatPath(item.icon)
      })
      const video = deepClone(this.formData.video)
      video.map((item, index) => {
        video[index].video_url = formatPath(item.video_url)
        video[index].pic_url = formatPath(item.pic_url)
      })
      const banner = deepClone(this.formData.banner)
      banner.map((item, index) => {
        banner[index].banner_url = formatPath(item.banner_url)
      })
      const content = deepClone(this.formData.content)
      content.map((item, index) => {
        content[index].content_url = formatPath(item.content_url)
      })
      const contact_units = deepClone(this.formData.contact_units)
      contact_units.map((item, index) => {
        contact_units[index].pic = contact_units[index].pic.map(formatPath)
      })
      return Object.assign({}, this.formData, { picture, navigation, video, banner, content, contact_units })
    },
    // 新增
    postAdd() {
      this.confirmLoading = true
      postPagesAdd(this.paramsFormat())
        .then((res) => {
          if (res.code === 200) {
            // const { data } = res
            // this.id = data.page_id
            this.$message.success('保存成功')
            // this.$router.replace({ name: 'customPageEdit', query: { id: this.id } })
            this.$store.dispatch('removeTab', this.$route.fullPath)
            this.handleCancel()
          }
        })
        .catch((e) => {
          this.$message.error('请求新增页面接口失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 编辑
    postEdit() {
      this.confirmLoading = true
      postPagesEdit(this.paramsFormat())
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            // this.handleCancel()
            this.getDetail()
            this.handleRefreshPreview()
          }
        })
        .catch((e) => {
          this.$message.error('请求编辑页面接口失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 添加导航
    handleAddNav() {
      this.formData.navigation.push(Object.assign({}, defaultNav))
    },
    // 添加视频
    handleAddVideo() {
      this.formData.video.push(Object.assign({}, defaultVideo))
    },
    // 添加展示图片
    handleAddContent() {
      this.formData.content.push(Object.assign({}, defaultContent))
    },
    // 添加轮播图
    handleAddBanner() {
      this.formData.banner.push(Object.assign({}, defaultBanner))
    },
    // 删除导航
    handleDeleteNav(event, item, index) {
      event.stopPropagation()
      this.$confirm({
        title: '确定要删除该组件?',
        onOk: () => {
          this.formData.navigation.splice(index, 1)
        }
      })
    },
    // 删除视频
    handleDeleteVideo(event, item, index) {
      event.stopPropagation()
      this.$confirm({
        title: '确定要删除该组件?',
        onOk: () => {
          this.formData.video.splice(index, 1)
        }
      })
    },
    // 删除轮播图
    handleDeleteBanner(event, item, index) {
      event.stopPropagation()
      this.$confirm({
        title: '确定要删除该组件?',
        onOk: () => {
          this.formData.banner.splice(index, 1)
        }
      })
    },
    // 删除展示图片
    handleDeleteContent(event, item, index) {
      event.stopPropagation()
      this.$confirm({
        title: '确定要删除该组件?',
        onOk: () => {
          this.formData.content.splice(index, 1)
        }
      })
    },
    // 添加产品说明图片
    // handleAddPic() {
    //   this.formData.picture.push('')
    // },
    // 删除产品说明图片
    // handleDeletePic(event, item, index) {
    //   event.stopPropagation()
    //   this.$confirm({
    //     title: '确定要删除?',
    //     onOk: () => {
    //       this.formData.picture.splice(index, 1)
    //     }
    //   })
    // },
    // 点击选择链接 导航
    handleSelectLink(item, index) {
      this.currentNavIndex = index
      this.$refs.link.showModal({
        id: item.goods_id || item.page_id,
        url: item.url,
        type: item.goods_id ? 'GOODS' : 'PAGE'
      })
    },
    // 确定选择链接 导航
    handleLinkOk(selected) {
      this.formData.navigation[this.currentNavIndex].goods_id = (selected.type === 'GOODS') ? selected.id : 0
      this.formData.navigation[this.currentNavIndex].page_id = (selected.type === 'PAGE') ? selected.id : 0
      this.formData.navigation[this.currentNavIndex].url = selected.url
    },
    // 轮播图点击选择链接
    handleSelectLinkB(item, index) {
      this.currentBannerUrl = index
      this.$refs.linkB.showModal({
        id: item.goods_id || item.page_id,
        url: item.url,
        type: item.goods_id ? 'GOODS' : 'PAGE'
      })
    },
    // 轮播图确定选择链接
    handleLinkOkB(selected) {
      this.formData.banner[this.currentBannerUrl].goods_id = (selected.type === 'GOODS') ? selected.id : 0
      this.formData.banner[this.currentBannerUrl].page_id = (selected.type === 'PAGE') ? selected.id : 0
      this.formData.banner[this.currentBannerUrl].jump_url = selected.url
    },
    // 展示图点击选择链接
    handleSelectLinkC(item, index) {
      this.currentContentUrl = index
      this.$refs.linkC.showModal({
        id: item.goods_id || item.page_id,
        url: item.url,
        type: item.goods_id ? 'GOODS' : 'PAGE'
      })
    },
    // 展示图确定选择链接
    handleLinkOkC(selected) {
      this.formData.content[this.currentContentUrl].goods_id = (selected.type === 'GOODS') ? selected.id : 0
      this.formData.content[this.currentContentUrl].page_id = (selected.type === 'PAGE') ? selected.id : 0
      this.formData.content[this.currentContentUrl].jump_url = selected.url
    },
    // 刷新页面效果
    handleRefreshPreview() {
      // 跨域问题
      // document.getElementById('pageIframe').contentWindow.location.reload(true)
      document.getElementById('pageIframe').src = this.formData.page_url + '?_auth=YES'
      // 向IFRAME通信
      this.postMessage()
    },
    // 删除联系页选项
    handleDeleteContact(item, index) {
      this.$confirm({
        title: '确定要删除?',
        onOk: () => {
          this.formData.contact_units.splice(index, 1)
        }
      })
    },
    // 添加联系页选项
    handleAddContact() {
      this.formData.contact_units.push(Object.assign({}, defaultContact))
    },
    isHome(e) {
      if (this.setDefault(this.brand_list, 1)) {
        this.is_home = !this.is_home
        if (e.target.checked) {
          this.formData.is_index = 'YES'
        } else {
          this.formData.is_index = 'NO'
        }
      } else {
        this.$message.warning('每个品牌都有创建首页，无需再创建')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.form-title {
  background: transparent;
  padding: 24px 0;
  zoom: 1;
  min-height: 48px;
  font-size: 16px;
  color: @heading-color;
  font-weight: 500;
}
.form-sub-title {
  background: transparent;
  padding-bottom: 20px;
  font-size: 12px;
  color: @heading-color;
}
.pr {
  position: relative;
}
.flex-box {
  display: flex;
  //justify-content: center;
  .flex-box-grow-1 {
    flex-grow: 1;
  }
}
.box {
  // display: flex;
  // min-width: 900px;
  position: relative;
}
.box-left {
  // flex-grow: 1;
  // min-width: 360px;
  max-width: 800px;
  min-width: 400px;
  margin-right: 400px;
}
.box-right {
  position: absolute;
  right: 0;
  top: 0;
  // top: 50%;
  // transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.2);
  padding: 0 10px 10px;
  z-index: 100;
}
.phone-box {
  width: 320px;
  height: 568px;
  background: #fff;
  overflow: hidden;
}

.drag-btn:hover {
  cursor: move;
}

.card{
  border: 1px solid #2C3541;
  .head{
    min-height: 48px;
    margin-bottom: -1px;
    padding: 0 10px;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
    font-size: 16px;
    background: transparent;
    border-bottom: 1px solid #2C3541;
    zoom: 1;
    display: flex;
    align-items: center;
    .title{
      padding: 8px 0;
      display: inline-block;
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .extra{
      flex: none
    }
  }
  .body{
    padding: 12px;
  }
}
</style>
